import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.nav`
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: auto;
  margin: 0;
  padding: 0;

  -ms-overflow-style: none;
  scrollbar-width: none;

  ${({ compact }) =>
    !!compact &&
    css`
      gap: 1rem;
    `}

  ${({ profile }) =>
    !!profile &&
    css`
      display: none;
      flex-direction: column;
      align-items: start;
      gap: 27px;

      ${breakpoint("tablet")`
        display: flex;
        padding-bottom: 24px;
      `}
    `}
`
